import React, { useEffect, useState } from 'react';
import api, { getApiBase, ficApi } from '../services/api';

// ── Ordinamento colonne ─────────────────────────────────────
function sortData(data, col, dir) {
  return [...(data||[])].sort((a, b) => {
    let va = a[col] != null ? a[col] : '';
    let vb = b[col] != null ? b[col] : '';
    if (!isNaN(parseFloat(va)) && !isNaN(parseFloat(vb))) {
      va = parseFloat(va); vb = parseFloat(vb);
    } else { va = String(va).toLowerCase(); vb = String(vb).toLowerCase(); }
    return dir === 'asc' ? (va > vb ? 1 : va < vb ? -1 : 0) : (va < vb ? 1 : va > vb ? -1 : 0);
  });
}

function SortTh({ col, label, align, sortCol, sortDir, onSort }) {
  const active = sortCol === col;
  return (
    <th onClick={() => onSort(col)} style={{
      padding:'8px 10px', background:'#f1f5f9', borderBottom:'2px solid #e5e7eb',
      fontSize:11, fontWeight:600, whiteSpace:'nowrap', textAlign:align||'left',
      cursor:'pointer', userSelect:'none',
    }}>
      {label}{' '}<span style={{color:active?'#b30000':'#ccc',fontSize:10}}>
        {active ? (sortDir==='asc' ? '▲' : '▼') : '⇅'}
      </span>
    </th>
  );
}

function useSortState(defaultCol, defaultDir) {
  const [sortCol, setSortCol] = React.useState(defaultCol || 'date');
  const [sortDir, setSortDir] = React.useState(defaultDir || 'desc');
  const onSort = React.useCallback((col) => {
    setSortCol(prev => {
      if (prev === col) { setSortDir(d => d === 'asc' ? 'desc' : 'asc'); return prev; }
      setSortDir('desc');
      return col;
    });
  }, []);
  return { sortCol, sortDir, onSort };
}


const eur = n => '€ ' + parseFloat(n||0).toLocaleString('it-IT',{minimumFractionDigits:2});
const fmtData = d => d ? d.substring(0,10).split('-').reverse().join('/') : '—';

const STATO_BADGE = {
  paid:     { cls:'badge-green',  label:'✅ Pagata' },
  not_paid: { cls:'badge-orange', label:'🟠 Non pagata' },
  overdue:  { cls:'badge-red',    label:'🔴 Scaduta' },
  partial:  { cls:'badge-orange', label:'🟡 Parziale' },
};



// ── Ordinamento colonne ────────────────────────────────────────
export default function FatturePage() {
  const [vista, setVista]  = useState('lista');
  const [fattSel, setFatt] = useState(null);

  if (vista==='nuova')     return <NuovaFattura onBack={()=>setVista('lista')} onSaved={()=>setVista('lista')} />;
  if (vista==='dettaglio') return <DettaglioFattura fatt={fattSel} onBack={()=>setVista('lista')} />;
  return <ListaFatture
    onNuova={()=>setVista('nuova')}
    onApri={f=>{setFatt(f);setVista('dettaglio');}}
  />;
}

// ── LISTA ──────────────────────────────────────────────────────
function ListaFatture({ onNuova, onApri }) {
  const [fatture, setFatture]   = useState([]);
  const { sortCol, sortDir, onSort } = useSortState('date', 'desc');
  const fattureSorted = React.useMemo(() => sortData(fatture, sortCol, sortDir), [fatture, sortCol, sortDir]);
  const [loading, setLoading]   = useState(true);
  const [pagina, setPagina]     = useState(1);
  const [totPagine, setTotPag]  = useState(1);
  const [filtroStato, setFiltro]= useState('');
  const [q, setQ]               = useState('');

  const carica = async (p=1) => {
    setLoading(true);
    try {
      const res = await ficApi.fatture(p);
      setFatture(res.data?.data || []);
      setTotPag(res.data?.last_page || 1);
      setPagina(p);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { carica(1); }, []);

  const calcStato = f => {
    const rate = f.payments_list || [];
    if (!rate.length) return f.payment_status || 'not_paid';

    const valide = rate.filter(p => p.status !== 'reversed');
    if (!valide.length) return 'paid';                       // interamente stornata

    if (valide.every(p => p.status === 'paid')) return 'paid';
    if (valide.some(p => p.status === 'paid')) return 'partial';

    // Nessuna rata incassata: scaduta se la scadenza è passata
    const oggi = new Date(); oggi.setHours(0,0,0,0);
    const scaduta = valide.some(p =>
      p.status === 'overdue' || (p.due_date && new Date(p.due_date) < oggi));
    return scaduta ? 'overdue' : 'not_paid';
  };

  const PER_PAGINA = 50;
  const filtrate = fattureSorted.filter(f => {
    const stato  = calcStato(f);
    const matchS = !filtroStato || stato===filtroStato;
    const matchQ = !q || f.entity?.name?.toLowerCase().includes(q.toLowerCase()) || String(f.number || f.numeration || '').includes(q);
    return matchS && matchQ;
  });

  const totPag = Math.max(1, Math.ceil(filtrate.length / PER_PAGINA));
  const visibili = filtrate.slice((pagina-1)*PER_PAGINA, pagina*PER_PAGINA);
  React.useEffect(() => { setPagina(1); }, [q, filtroStato, sortCol, sortDir]);

  return (
    <div className="page-content">
      <div style={{display:'flex',gap:12,marginBottom:16,flexWrap:'wrap'}}>
        <input className="form-control" style={{maxWidth:260}}
          placeholder="🔍 Cliente o numero..."
          value={q} onChange={e=>setQ(e.target.value)} />
        <select className="form-control" style={{maxWidth:180}}
          value={filtroStato} onChange={e=>setFiltro(e.target.value)}>
          <option value="">Tutti gli stati</option>
          <option value="overdue">🔴 Scadute</option>
          <option value="not_paid">🟠 Non pagate</option>
          <option value="partial">🟡 Parziali</option>
          <option value="paid">✅ Pagate</option>
        </select>
        <button className="btn btn-primary" onClick={onNuova}>➕ Nuova fattura</button>
        <span style={{marginLeft:'auto',alignSelf:'center',color:'#9ca3af',fontSize:13}}>
          {filtrate.length} fatture · pag. {pagina}/{totPag}
        </span>
      </div>

      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <div className="card" style={{padding:0}}>
          <div className="table-wrap">
            <table className="q-table">
              <thead><tr>
                <SortTh col='number' label='N°' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><SortTh col='date' label='Data' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><SortTh col='entity_name' label='Cliente' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} />
                <SortTh col='amount_gross' label='Totale' align='right' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><SortTh col='payment_terms' label='Scadenza' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><SortTh col='status' label='Stato' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><th></th>
              </tr></thead>
              <tbody>
                {visibili.length===0 && (
                  <tr><td colSpan={7} style={{textAlign:'center',color:'#9ca3af',padding:32}}>Nessuna fattura</td></tr>
                )}
                {visibili.map(f => {
                  const stato = calcStato(f);
                  const badge = STATO_BADGE[stato] || {cls:'badge-gray',label:stato};
                  const isScaduta = stato==='overdue';
                  return (
                    <tr key={f.id} style={{background:isScaduta?'#fff5f5':undefined,cursor:'pointer'}}
                      onClick={()=>onApri(f)}>
                      <td><strong>{f.number || f.numeration}</strong></td>
                      <td style={{fontSize:12}}>{fmtData(f.date)}</td>
                      <td><strong>{f.entity?.name || '—'}</strong></td>
                      <td style={{textAlign:'right',fontWeight:600}}>{eur(f.amount_gross)}</td>
                      <td style={{fontSize:12,color:isScaduta?'#dc3545':'#6b7280'}}>{fmtData(f.payment_terms?.due_date || f.due_date)}</td>
                      <td><span className={`badge ${badge.cls}`}>{badge.label}</span></td>
                      <td style={{display:'flex',gap:4}} onClick={e=>e.stopPropagation()}>
                        {f.attachment_url &&
                          <a href={f.attachment_url} target="_blank" rel="noopener noreferrer"
                             className="btn btn-secondary btn-sm">🖨️ PDF</a>}
                        <button className="btn btn-secondary btn-sm" onClick={()=>onApri(f)}>Apri →</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {totPag>1 && (
        <div style={{display:'flex',gap:8,marginTop:12,justifyContent:'center'}}>
          <button className="btn btn-secondary btn-sm" disabled={pagina<=1} onClick={()=>setPagina(pagina-1)}>⬅</button>
          <span style={{alignSelf:'center',fontSize:13}}>{pagina}/{totPag}</span>
          <button className="btn btn-secondary btn-sm" disabled={pagina>=totPag} onClick={()=>setPagina(pagina+1)}>➡</button>
        </div>
      )}
    </div>
  );
}

// ── DETTAGLIO ──────────────────────────────────────────────────
function DettaglioFattura({ fatt, onBack }) {
  const [dettaglio, setDettaglio] = React.useState(null);
  const [loading, setLoading]    = React.useState(true);
  const [salvandoPag, setSalvandoPag] = React.useState(false);

  const ricarica = React.useCallback(() => {
    fetch(`${getApiBase()}/api/fic/fattura/${fatt.id}`, {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('quindi_token') }
    }).then(r => r.json())
      .then(d => setDettaglio(d.data || fatt))
      .catch(() => setDettaglio(fatt))
      .finally(() => setLoading(false));
  }, [fatt]);

  React.useEffect(() => {
    if (!fatt) return;
    ricarica();
  }, [fatt, ricarica]);

  const cambiaPagamento = async (pagata) => {
    setSalvandoPag(true);
    try {
      const res = await fetch(`${getApiBase()}/api/fic/fattura/${fatt.id}/pagamento`, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('quindi_token'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ pagata }),
      });
      if (!res.ok) {
        const j = await res.json().catch(()=>({}));
        throw new Error(j.error || 'Errore aggiornamento');
      }
      setLoading(true);
      ricarica();
    } catch(e) {
      alert('Errore: ' + e.message);
    } finally { setSalvandoPag(false); }
  };

  if (!fatt) return null;
  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  const f2 = dettaglio || fatt;

  const calcStato = f => {
    if (f.payment_status) return f.payment_status;
    if (!f.payments_list?.length) return 'not_paid';
    const scaduta = f.payments_list.some(p => p.status==='overdue');
    if (scaduta) return 'overdue';
    return f.payments_list.every(p => p.status==='paid') ? 'paid' : 'partial';
  };

  const stato = calcStato(f2);
  const badge = STATO_BADGE[stato] || {cls:'badge-gray',label:stato};
  const scaduta = stato==='overdue';
  const totIva  = (f2.amount_gross||0) - (f2.amount_net||0);

  return (
    <div className="page-content">
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16,flexWrap:'wrap'}}>
        <button className="btn btn-secondary" onClick={onBack}>⬅ Fatture</button>
        <h2 style={{margin:0}}>Fattura N° {f2.number || f2.numeration || '—'}</h2>
        <span className={`badge ${badge.cls}`}>{badge.label}</span>
        <div style={{marginLeft:'auto',display:'flex',gap:6,alignItems:'center'}}>
          {stato !== 'paid' ? (
            <button className="btn btn-sm" disabled={salvandoPag}
              onClick={()=>cambiaPagamento(true)}
              style={{background:'#16a34a',color:'#fff',border:'none'}}>
              {salvandoPag ? '...' : '✅ Segna pagata'}
            </button>
          ) : (
            <button className="btn btn-sm" disabled={salvandoPag}
              onClick={()=>cambiaPagamento(false)}
              style={{background:'#fef2f2',color:'#dc2626',border:'none'}}>
              {salvandoPag ? '...' : '↩️ Segna non pagata'}
            </button>
          )}
          {f2.attachment_url && (
            <a href={f2.attachment_url} target="_blank" rel="noopener noreferrer"
               className="btn btn-secondary btn-sm">
              🖨️ PDF
            </a>
          )}
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,maxWidth:800}}>

        {/* INFO */}
        <div className="card">
          <div className="card-title" style={{marginBottom:12}}>📋 Dettagli</div>
          <table style={{width:'100%',fontSize:13}}>
            <tbody>
              {[
                ['Cliente',  f2.entity?.name],
                ['Data',     fmtData(f2.date)],
                ['Scadenza', fmtData(f2.next_due_date || f2.payment_terms?.due_date || f2.due_date)],
                ['Oggetto',  f2.visible_subject || f2.subject],
                ['Note',     f2.notes || f2.note],
              ].filter(([,v])=>v).map(([k,v])=>(
                <tr key={k}>
                  <td style={{color:'#9ca3af',padding:'4px 0',width:'35%'}}>{k}</td>
                  <td style={{color:k==='Scadenza'&&scaduta?'#dc3545':'inherit'}}>{v}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* IMPORTI */}
        <div className="card">
          <div className="card-title" style={{marginBottom:12}}>💰 Importi</div>
          <table style={{width:'100%',fontSize:13}}>
            <tbody>
              <tr><td style={{color:'#9ca3af',padding:'4px 0'}}>Imponibile</td>
                  <td style={{textAlign:'right'}}>{eur(f2.amount_net)}</td></tr>
              <tr><td style={{color:'#9ca3af',padding:'4px 0'}}>IVA</td>
                  <td style={{textAlign:'right'}}>{eur(totIva)}</td></tr>
              <tr style={{borderTop:'2px solid #e5e7eb'}}>
                  <td style={{padding:'8px 0',fontWeight:700}}>Totale</td>
                  <td style={{textAlign:'right',fontWeight:700,color:'#b30000',fontSize:16}}>{eur(f2.amount_gross)}</td></tr>
            </tbody>
          </table>

          {/* Pagamenti */}
          {f2.payments_list?.length > 0 && (
            <div style={{marginTop:12,borderTop:'1px solid #f3f4f6',paddingTop:10}}>
              <div style={{fontWeight:600,fontSize:12,color:'#6b7280',marginBottom:6}}>Scadenze pagamento</div>
              {f2.payments_list.map((p,i)=>(
                <div key={i} style={{display:'flex',justifyContent:'space-between',fontSize:12,padding:'3px 0'}}>
                  <span style={{color:p.status==='overdue'?'#dc3545':'#6b7280'}}>{fmtData(p.due_date)}</span>
                  <span style={{fontWeight:600}}>{eur(p.amount)}</span>
                  <span className={`badge ${p.status==='paid'?'badge-green':p.status==='overdue'?'badge-red':'badge-gray'}`} style={{fontSize:10}}>
                    {p.status==='paid'?'✅':p.status==='overdue'?'🔴':'⏳'}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* SOLLECITI */}
        {(stato === 'not_paid' || stato === 'overdue' || stato === 'partial') && (
          <div className="card" style={{gridColumn:'1/-1',padding:0}}>
            <SollecitiPanel fattura={f2} stato={stato} />
          </div>
        )}

        {/* RIGHE */}
        {(f2.items_list?.length > 0 || false) && (
          <div className="card" style={{gridColumn:'1/-1',padding:0}}>
            <div style={{padding:'12px 16px',fontWeight:600,fontSize:13,borderBottom:'1px solid #e5e7eb'}}>🔧 Voci</div>
            <div className="table-wrap">
              <table className="q-table">
                <thead><tr>
                  <th>Descrizione</th>
                  <th style={{textAlign:'center'}}>Qtà</th>
                  <th style={{textAlign:'right'}}>Prezzo netto</th>
                  <th style={{textAlign:'center'}}>IVA</th>
                  <th style={{textAlign:'right'}}>Totale</th>
                </tr></thead>
                <tbody>
                  {(f2.items_list||[]).map((item,i)=>(
                    <tr key={i}>
                      <td>{item.name}</td>
                      <td style={{textAlign:'center'}}>{item.qty}</td>
                      <td style={{textAlign:'right'}}>{eur(item.net_price)}</td>
                      <td style={{textAlign:'center',fontSize:11,color:'#6b7280'}}>{item.vat?.value||22}%</td>
                      <td style={{textAlign:'right',fontWeight:600}}>{eur(parseFloat(item.qty||1)*parseFloat(item.net_price||0))}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── NUOVA FATTURA ──────────────────────────────────────────────
function NuovaFattura({ onBack, onSaved }) {
  const [clienti, setClienti]   = useState([]);
  const [prodotti, setProdotti] = useState([]);
  const [cercaC, setCercaC]     = useState('');
  const [clienteSel, setClSel] = useState(null);
  const [form, setForm]         = useState({
    data:     new Date().toISOString().split('T')[0],
    scadenza: '',
    oggetto:  '',
    note:     '',
  });
  const [righe, setRighe]   = useState([{descrizione:'',quantita:1,prezzo:0,iva:22,sconto:0}]);
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');
  const [cercaP, setCercaP] = useState('');

  useEffect(() => {
    api.get('/preventivi/clienti').then(r => setClienti(r.data?.data || [])).catch(console.error);
    api.get('/preventivi/prodotti').then(r => setProdotti(r.data?.data || [])).catch(console.error);
  }, []);

  const clientiFiltrati = clienti.filter(c =>
    !cercaC || c.name?.toLowerCase().includes(cercaC.toLowerCase())
  );
  const prodottiFiltrati = prodotti.filter(p =>
    !cercaP || p.name?.toLowerCase().includes(cercaP.toLowerCase()) || (p.code||'').toLowerCase().includes(cercaP.toLowerCase())
  );

  const aggRiga  = () => setRighe(r => [...r, {descrizione:'',quantita:1,prezzo:0,iva:22,sconto:0}]);
  const rimuRiga = i  => setRighe(r => r.filter((_,j) => j!==i));
  const setRiga  = (i,k,v) => setRighe(r => r.map((x,j) => j===i ? {...x,[k]:v} : x));

  const applicaProdotto = (i, prod) => {
    setRiga(i,'descrizione', prod.name);
    setRiga(i,'prodotto_id', prod.id);
    setRiga(i,'prezzo',      parseFloat(prod.net_price||0));
    setRiga(i,'iva',         prod.vat?.value || 22);
    setCercaP('');
  };

  const totImponibile = righe.reduce((s,r) => {
    const base = parseFloat(r.quantita||1)*parseFloat(r.prezzo||0);
    return s + base - base*parseFloat(r.sconto||0)/100;
  }, 0);
  const totIva = righe.reduce((s,r) => {
    const base = parseFloat(r.quantita||1)*parseFloat(r.prezzo||0);
    const imp  = base - base*parseFloat(r.sconto||0)/100;
    return s + imp*parseFloat(r.iva||22)/100;
  }, 0);

  const salva = async () => {
    if (!clienteSel) { setError('Seleziona un cliente.'); return; }
    setSaving(true); setError('');
    try {
      await api.post('/fatture', {
        cliente_fic_id: clienteSel.id,
        cliente_nome:   clienteSel.name,
        data:           form.data,
        scadenza:       form.scadenza || null,
        oggetto:        form.oggetto,
        note:           form.note,
        righe:          righe.filter(r => r.descrizione.trim()),
      });
      onSaved();
    } catch(e) {
      setError(e.response?.data?.error || 'Errore nel salvataggio su FIC.');
    } finally { setSaving(false); }
  };

  return (
    <div className="page-content">
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16}}>
        <button className="btn btn-secondary" onClick={onBack}>⬅ Indietro</button>
        <h2 style={{margin:0}}>➕ Nuova fattura</h2>
      </div>

      {error && <div className="error-msg" style={{marginBottom:16}}>{error}</div>}

      <div style={{maxWidth:900}}>

        {/* CLIENTE */}
        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>👥 Cliente</div>
          {clienteSel ? (
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <strong style={{flex:1}}>{clienteSel.name}</strong>
              <button className="btn btn-secondary btn-sm" onClick={()=>{setClSel(null);setCercaC('');}}>✕ Cambia</button>
            </div>
          ) : (
            <div>
              <input className="form-control" placeholder="Cerca cliente FIC..."
                value={cercaC} onChange={e=>setCercaC(e.target.value)} style={{marginBottom:8}} />
              {cercaC && (
                <div style={{border:'1px solid #e5e7eb',borderRadius:6,maxHeight:200,overflowY:'auto',background:'#fff'}}>
                  {clientiFiltrati.slice(0,15).map(c=>(
                    <div key={c.id} onClick={()=>{setClSel(c);setCercaC(c.name);}}
                      style={{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #f3f4f6',fontSize:13}}
                      onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                      onMouseLeave={e=>e.currentTarget.style.background=''}>
                      <strong>{c.name}</strong>
                    </div>
                  ))}
                  {clientiFiltrati.length===0&&<div style={{padding:12,color:'#9ca3af',fontSize:13}}>Nessun cliente trovato</div>}
                </div>
              )}
            </div>
          )}
        </div>

        {/* DATI */}
        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>📋 Dati fattura</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Data</label>
              <input type="date" className="form-control" value={form.data}
                onChange={e=>setForm(f=>({...f,data:e.target.value}))} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Scadenza pagamento</label>
              <input type="date" className="form-control" value={form.scadenza}
                onChange={e=>setForm(f=>({...f,scadenza:e.target.value}))} />
            </div>
            <div className="form-group" style={{margin:0,gridColumn:'1/-1'}}>
              <label className="form-label">Oggetto</label>
              <input className="form-control" value={form.oggetto}
                onChange={e=>setForm(f=>({...f,oggetto:e.target.value}))}
                placeholder="Es. Manutenzione impianti antincendio..." />
            </div>
          </div>
        </div>

        {/* RIGHE */}
        <div className="card" style={{marginBottom:16}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
            <span className="card-title">🔧 Voci</span>
            <button className="btn btn-secondary btn-sm" onClick={aggRiga}>➕ Riga</button>
          </div>

          <input className="form-control" placeholder="🔍 Cerca nel catalogo FIC..."
            value={cercaP} onChange={e=>setCercaP(e.target.value)} style={{marginBottom:6}} />
          {cercaP && (
            <div style={{border:'1px solid #e5e7eb',borderRadius:6,maxHeight:150,overflowY:'auto',marginBottom:8,background:'#fff',fontSize:12}}>
              {prodottiFiltrati.slice(0,10).map(p=>(
                <div key={p.id} style={{padding:'6px 12px',cursor:'pointer',borderBottom:'1px solid #f3f4f6',display:'flex',gap:8}}
                  onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                  onMouseLeave={e=>e.currentTarget.style.background=''}
                  onClick={()=>applicaProdotto(righe.length-1,p)}>
                  <span style={{flex:1}}>{p.name}</span>
                  <span style={{color:'#6b7280'}}>€{parseFloat(p.net_price||0).toFixed(2)}</span>
                </div>
              ))}
            </div>
          )}

          <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
            <thead><tr style={{background:'#f9fafb'}}>
              <th style={{padding:'6px',textAlign:'left'}}>Descrizione</th>
              <th style={{padding:'6px',textAlign:'center',width:60}}>Qtà</th>
              <th style={{padding:'6px',textAlign:'right',width:90}}>Prezzo</th>
              <th style={{padding:'6px',textAlign:'center',width:55}}>IVA%</th>
              <th style={{padding:'6px',textAlign:'center',width:55}}>Sc.%</th>
              <th style={{padding:'6px',textAlign:'right',width:90}}>Totale</th>
              <th style={{width:32}}></th>
            </tr></thead>
            <tbody>
              {righe.map((r,i)=>{
                const base=parseFloat(r.quantita||1)*parseFloat(r.prezzo||0);
                const tot=base-base*parseFloat(r.sconto||0)/100;
                return (
                  <tr key={i}>
                    <td style={{padding:'3px'}}><input className="form-control" value={r.descrizione} onChange={e=>setRiga(i,'descrizione',e.target.value)} style={{fontSize:12,padding:'4px 6px'}} /></td>
                    <td style={{padding:'3px'}}><input type="number" className="form-control" value={r.quantita} min={1} onChange={e=>setRiga(i,'quantita',e.target.value)} style={{fontSize:12,padding:'4px 6px',textAlign:'center'}} /></td>
                    <td style={{padding:'3px'}}><input type="number" className="form-control" value={r.prezzo} min={0} step={0.01} onChange={e=>setRiga(i,'prezzo',e.target.value)} style={{fontSize:12,padding:'4px 6px',textAlign:'right'}} /></td>
                    <td style={{padding:'3px'}}><input type="number" className="form-control" value={r.iva} min={0} onChange={e=>setRiga(i,'iva',e.target.value)} style={{fontSize:12,padding:'4px 6px',textAlign:'center'}} /></td>
                    <td style={{padding:'3px'}}><input type="number" className="form-control" value={r.sconto} min={0} max={100} onChange={e=>setRiga(i,'sconto',e.target.value)} style={{fontSize:12,padding:'4px 6px',textAlign:'center'}} /></td>
                    <td style={{padding:'3px',textAlign:'right',fontWeight:600,fontSize:12}}>{eur(tot)}</td>
                    <td style={{padding:'3px'}}><button className="btn btn-danger btn-sm" onClick={()=>rimuRiga(i)}>✕</button></td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr><td colSpan={5} style={{padding:'8px 6px',textAlign:'right',color:'#6b7280',fontSize:13}}>Imponibile:</td><td style={{padding:'8px 6px',textAlign:'right',fontWeight:600}}>{eur(totImponibile)}</td><td></td></tr>
              <tr><td colSpan={5} style={{padding:'3px 6px',textAlign:'right',color:'#6b7280',fontSize:13}}>IVA:</td><td style={{padding:'3px 6px',textAlign:'right',fontWeight:600}}>{eur(totIva)}</td><td></td></tr>
              <tr><td colSpan={5} style={{padding:'8px 6px',textAlign:'right',fontWeight:700,borderTop:'2px solid #e5e7eb'}}>Totale:</td><td style={{padding:'8px 6px',textAlign:'right',fontWeight:700,color:'#b30000',fontSize:15,borderTop:'2px solid #e5e7eb'}}>{eur(totImponibile+totIva)}</td><td></td></tr>
            </tfoot>
          </table>
        </div>

        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:8}}>📝 Note</div>
          <textarea className="form-control" rows={3} value={form.note}
            onChange={e=>setForm(f=>({...f,note:e.target.value}))}
            placeholder="Note aggiuntive..." />
        </div>

        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-primary" onClick={salva} disabled={saving}>
            {saving?'Salvataggio...':'💾 Crea fattura'}
          </button>
          <button className="btn btn-secondary" onClick={onBack}>Annulla</button>
        </div>
      </div>
    </div>
  );
}

// ── SOLLECITI ──────────────────────────────────────────────────
function SollecitiPanel({ fattura, stato }) {
  const [solleciti, setSolleciti] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [showForm, setForm]       = useState(false);
  const [form, setF]              = useState({ tipo:'email', note:'', esito:'' });
  const [saving, setSaving]       = useState(false);
  const [msg, setMsg]             = useState('');

  const carica = async () => {
    try {
      const r = await api.get(`/solleciti?fattura_id=${fattura.id}`);
      setSolleciti(r.data?.data || []);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { carica(); }, [fattura.id]);

  const invia = async () => {
    setSaving(true); setMsg('');
    try {
      const res = await api.post('/solleciti', {
        fattura_id:     fattura.id,
        fattura_numero: fattura.number || fattura.numeration,
        cliente_nome:   fattura.entity?.name,
        cliente_email:  fattura.entity?.email || '',
        importo:        fattura.amount_gross,
        tipo:           form.tipo,
        note:           form.note,
        esito:          form.esito || null,
      });
      if (res.data.emailError) {
        setMsg(`⚠️ Sollecito registrato ma email fallita: ${res.data.emailError}`);
      } else if (form.tipo === 'email') {
        setMsg('✅ Sollecito registrato ed email inviata!');
      } else {
        setMsg('✅ Sollecito telefonico registrato!');
      }
      setForm({ tipo:'email', note:'', esito:'' });
      setForm(f=>({...f}));
      await carica();
      setForm({ tipo:'email', note:'', esito:'' });
    } catch(e) { setMsg('Errore: ' + (e.response?.data?.error||e.message)); }
    finally { setSaving(false); }
  };

  const fmtDateTime = d => d ? new Date(d).toLocaleString('it-IT',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'}) : '—';

  const ESITO_BADGE = {
    nessuna_risposta:   {cls:'badge-gray',   label:'Nessuna risposta'},
    promessa_pagamento: {cls:'badge-orange', label:'Promessa pagamento'},
    contestazione:      {cls:'badge-red',    label:'Contestazione'},
    pagato:             {cls:'badge-green',  label:'Pagato'},
  };

  return (
    <div>
      <div style={{padding:'12px 16px',borderBottom:'1px solid #e5e7eb',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <span style={{fontWeight:600,fontSize:13}}>📞 Solleciti</span>
        <button className="btn btn-secondary btn-sm" onClick={()=>setForm(v=>!v)}>
          {showForm?'✕ Chiudi':'➕ Nuovo sollecito'}
        </button>
      </div>

      {showForm && (
        <div style={{padding:'14px 16px',background:'#fafafa',borderBottom:'1px solid #e5e7eb'}}>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:10}}>
            <div>
              <label className="form-label">Tipo</label>
              <select className="form-control" value={form.tipo} onChange={e=>setF(f=>({...f,tipo:e.target.value}))}>
                <option value="telefonico">📞 Telefonico</option>
                <option value="email">📧 Email</option>
              </select>
            </div>
            <div>
              <label className="form-label">Esito</label>
              <select className="form-control" value={form.esito} onChange={e=>setF(f=>({...f,esito:e.target.value}))}>
                <option value="">— Esito —</option>
                <option value="nessuna_risposta">Nessuna risposta</option>
                <option value="promessa_pagamento">Promessa di pagamento</option>
                <option value="contestazione">Contestazione</option>
                <option value="pagato">Pagato</option>
              </select>
            </div>
          </div>
          <div style={{marginBottom:10}}>
            <label className="form-label">Note</label>
            <textarea className="form-control" rows={2} value={form.note}
              onChange={e=>setF(f=>({...f,note:e.target.value}))}
              placeholder={form.tipo==='email'?'Testo aggiuntivo nell\'email...':'Note sulla telefonata...'} />
          </div>
          {form.tipo==='email' && !fattura.entity?.email && (
            <div style={{background:'#fff7ed',border:'1px solid #fed7aa',borderRadius:6,padding:'8px 12px',fontSize:12,color:'#92400e',marginBottom:8}}>
              ⚠️ Email cliente non disponibile su FIC — il sollecito verrà registrato ma non inviato.
            </div>
          )}
          {msg && <div style={{fontSize:12,color:msg.includes('✅')?'#16a34a':'#dc2626',marginBottom:8}}>{msg}</div>}
          <button className="btn btn-primary btn-sm" onClick={invia} disabled={saving}>
            {saving?'...':form.tipo==='email'?'📧 Registra e invia email':'📞 Registra sollecito'}
          </button>
        </div>
      )}

      {loading ? <div style={{padding:16,textAlign:'center',color:'#9ca3af',fontSize:13}}>Caricamento...</div> : (
        solleciti.length === 0 ? (
          <div style={{padding:16,textAlign:'center',color:'#9ca3af',fontSize:13}}>Nessun sollecito registrato</div>
        ) : (
          <div>
            {solleciti.map(s => (
              <div key={s.id} style={{padding:'10px 16px',borderBottom:'1px solid #f3f4f6',display:'flex',gap:12,alignItems:'flex-start'}}>
                <span style={{fontSize:18}}>{s.tipo==='email'?'📧':'📞'}</span>
                <div style={{flex:1}}>
                  <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:2}}>
                    <span style={{fontSize:12,fontWeight:600}}>{s.tipo==='email'?'Email':'Telefonico'}</span>
                    <span style={{fontSize:11,color:'#9ca3af'}}>{fmtDateTime(s.data_sollecito)}</span>
                    {s.esito && <span className={`badge ${ESITO_BADGE[s.esito]?.cls||'badge-gray'}`} style={{fontSize:10}}>{ESITO_BADGE[s.esito]?.label||s.esito}</span>}
                  </div>
                  {s.note && <div style={{fontSize:12,color:'#6b7280',fontStyle:'italic'}}>{s.note}</div>}
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
}
